import { api } from 'api'
import { useMutation } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useFetchAccountsInfo = () => {
  return useMutation({
    mutationFn: (id) => api.users.getAccountsInfo(id),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось удалить пользователя',
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
  })
}
